<template>
  <Navbar />

  <div class="min-h-screen bg-gray-50 pt-32 mx-1 pb-16">
    <!-- Imagem de capa -->
    <div v-if="coverImage" class="flex justify-center">
      <img
          :src="coverImage"
          alt="Imagem de capa"
          class="w-full max-w-5xl h-[280px] md:h-[400px] object-cover object-center rounded-3xl shadow-lg"
          loading="lazy"
      />
    </div>

    <!-- Título -->
    <div class="max-w-5xl mx-auto">
      <h1 class="mt-8 text-3xl md:text-4xl font-extrabold text-gray-800 text-center">
        {{ pageData.title }}
      </h1>
    </div>

    <!-- Conteúdo -->
    <div class="max-w-5xl mx-auto px-4 py-10 mb-10">
      <div class="prose prose-lg prose-blue max-w-none mx-auto" v-if="pageData.content" v-html="pageData.content"></div>
      <div v-else class="text-center text-gray-400 py-20">Conteúdo em breve...</div>
    </div>
  </div>

  <Footer />
</template>

<script setup>
import { computed, watch, onMounted } from 'vue';
import { useHead } from '@vueuse/head';
import Navbar from "@/components/sitegamificacao/Navbar.vue";
import Footer from "@/components/sitegame/Footer.vue";

const props = defineProps({
  page: { type: Object, required: true },
  lang: { type: String, default: 'pt' }
});

const pageData = computed(() => {
  if (props.lang === 'en' && props.page.en) {
    return { ...props.page, ...props.page.en };
  }
  return props.page;
});

const coverImage = computed(() => {
  if (Array.isArray(pageData.value.image) && pageData.value.image.length > 0) {
    return pageData.value.image[0];
  }
  if (typeof pageData.value.image === 'string' && pageData.value.image) {
    return pageData.value.image;
  }
  return '/logo.png';
});

/* ========== SEO DINÂMICO ========== */
function setMetaTags() {
  if (!pageData.value || !pageData.value.title) return;

  const title = pageData.value.title || 'MitoGames – Blog';
  const description = pageData.value.description || 'Artigos, novidades e conteúdos sobre games e projetos da MitoGames.';
  const url = typeof window !== 'undefined' ? window.location.href : '';
  const image = coverImage.value;

  useHead({
    title,
    meta: [
      { name: 'description', content: description },
      { property: 'og:title', content: title },
      { property: 'og:description', content: description },
      { property: 'og:image', content: image },
      { property: 'og:url', content: url },
      { property: 'twitter:title', content: title },
      { property: 'twitter:description', content: description },
      { property: 'twitter:image', content: image },
      { property: 'twitter:card', content: 'summary_large_image' },
      { name: 'robots', content: 'index, follow' }
    ],
    link: [
      { rel: 'canonical', href: url }
    ],
    script: [
      {
        type: 'application/ld+json',
        children: JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'Article',
          'headline': title,
          'description': description,
          'image': image,
          'author': {
            '@type': 'Organization',
            'name': 'MitoGames'
          },
          'datePublished': pageData.value.createdAt || '', // ajuste conforme sua estrutura
          'publisher': {
            '@type': 'Organization',
            'name': 'MitoGames',
            'logo': {
              '@type': 'ImageObject',
              'url': 'https://mitogames.com.br/img/logo.bbeaf08a.png'
            }
          }
        })
      }
    ]
  });
}

/* =============================== */

onMounted(setMetaTags);
watch(pageData, setMetaTags);
</script>


<style scoped>
.prose {
  font-size: 1.15rem;
}
</style>
